module.exports = __webpack_public_path__ + "static/wallet-24b51c59b6ee432326d235b8dfeb9140.jpeg";